$(document).ready(function () {
	var navToggle = $('.js-nav-open');
	var closeNav = $('.js-close-rewards-nav');

	navToggle.on('click', function (e) { e.stopPropagation(); toggleNav(e); });
	closeNav.on('click', function (e) { e.stopPropagation(); toggleCloseNav(e); });

	$('.js-nav-toggle-children').on('click', function (e) { mobileNavItem(e); });

	// show rewards menu to start on desktop
	if (window.innerWidth >= 960) {
		$('.header-nav-rewards').addClass('open');
		$('.header-nav-rewards').removeClass('initial-load');
	}

	function toggleNav(e) {
		$('.header-nav-rewards').toggleClass('open');

		if ($('.header-nav-rewards').hasClass('open')) {
			$('body').addClass('nav-open');
		}
		else {
			$('body').removeClass('nav-open');
		}
	}
	 
	function toggleCloseNav(e) {
		$('.header-nav-rewards').removeClass('open');

		if ($('.header-nav-rewards').hasClass('open')) {
			$('body').addClass('nav-open');
		}
		else {
			$('body').removeClass('nav-open');
		}
	}

	// clicking on items in mobile nav
	function mobileNavItem(e) {
		e.preventDefault();
		var target = $(e.currentTarget);
		var parent = target.closest('li');

		$(parent).find('> ul').slideToggle();
		$(parent).toggleClass('open');
	}
});